// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonShortNouns } from "./common-short-fields";

export const platformAdminAssetsObjectSpaces = {
  columns: {
    displayName: "Display Name",
    writePolicy: "Write Access",
    status: commonShortNouns.status,
    assetCount: "Assets",
    capacity: "Capacity",
    quota: "Quota",
    latestWrite: "Latest Write",
    granteeType: "Grantee Type",
    grantee: "Grantee",
    accessLevel: "Access",
  },
  actions: {
    createSpacePolicy: "Govern Object Space",
    editPolicy: "Edit Write Access",
    onboardGovernance: "Bring Under Governance",
    grant: "Grants",
    createGrant: "Create Grant",
    removeGrant: "Remove",
  },
  drawer: {
    assetGovernance: "Asset Governance · {name}",
    assetGovernanceShort: "Asset Governance",
    deleteProtection: "Delete Protection",
    references: "Reference Details",
    referencesSubtitle:
      "Asset references are read directly from asset-center, not inferred locally by business systems.",
    grantTitle: "Object Space Grants · {name}",
    grantTitleShort: "Object Space Grants",
    grantSummary: "Grant Summary",
    grantRules: "Grant Rules",
  },
  objects: {
    objectSpaceGrant: "Object Space Grant",
  },
  fields: {
    deleteStatus: "Delete Status",
    referenceCount: "Reference Count",
    businessReferenceCount: "Business References",
    businessReferenceSnapshotCount: "Historical Source Hints",
    objectSpace: "Object Space",
    quota: "Quota Limit",
    storageBackend: "Storage Backend",
    spacePolicy: "Write Access",
    spaceStatus: "Space Status",
    grantCount: "Grant Count",
    blockingReasons: "Blocking Reasons",
    governanceWarnings: "Governance Warnings",
  },
  form: {
    objectSpacePolicyTitle: "Object Space Governance · {name}",
    objectSpacePolicyCreate: "Govern Object Space",
    objectSpaceKey: "Object Space Key",
    objectSpaceKeyRequired: "Please enter object space key",
    displayName: "Display Name",
    scopeType: "Scope Type",
    scopeTypeRequired: "Please select scope type",
    scopeValue: "Scope Value",
    scopeValueRequired: "Please enter scope value",
    writePolicy: "Write Access",
    writePolicyRequired: "Please select write access",
    quotaGb: "Space Quota",
    quotaGbPlaceholder: "Leave blank for unlimited",
    quotaGbHelp:
      "Configure the total quota for this object space in GB. Leave blank for unlimited.",
    status: commonShortNouns.status,
    statusRequired: "Please select status",
    grantCreateTitle: "Create Object Space Grant · {name}",
    grantCreateTitleShort: "Create Object Space Grant",
    grantTargetType: "Grantee Type",
    grantTargetTypeRequired: "Please select grantee type",
    grantTarget: "Grantee",
    grantTargetRequired: "Please enter grantee",
    accessLevel: "Access Level",
    accessLevelRequired: "Please select access level",
    removeGrantTitle: "Remove Grant",
    removeGrantDescription: "Remove {type}:{value}?",
    noSelectedSpace: "No object space selected",
  },
  errors: {
    partialLoadFailed:
      "Failed to read part of asset center data ({count} requests did not succeed)",
    grantLoadFailed: "Failed to load object space grants",
    grantRemoveFailed: "Failed to remove object space grant",
    policyUpdateFailed: "Failed to update object space policy",
    policyCreateFailed: "Failed to create object space policy",
    grantCreateFailed: "Failed to create object space grant",
  },
} as const;
